module.exports = __webpack_public_path__ + "static/media/预约-会员.f94e795d.svg";